export default __webpack_public_path__ + "static/media/Notice.1f79d536.svg";